import React from 'react';
import { useTranslation } from 'react-i18next';
import { GetPaidManualVerificationModal } from '@/types/modal';
import { ErrorModal, LoadingBodyModal, StandardModal } from '@/components/molecules/common/Modal';
import { useTriggerGetPaidManualVerification } from '@/hooks/client';

const GetPaidManualVerification: React.FC<{ modal: GetPaidManualVerificationModal }> = ({ modal }) => {
  const { t } = useTranslation();
  const mutation = useTriggerGetPaidManualVerification(modal.client.clientId);

  const body = mutation.isLoading ? (
    <LoadingBodyModal height={40} />
  ) : (
    <p>
      {t('client.get_paid.manual_verification_description', {
        email: modal.client.email,
      })}
    </p>
  );

  if (mutation.isError && mutation.error) {
    return (
      <ErrorModal
        title={t('common.operation_error')}
        error={{
          kind: 'QueryError',
          message: mutation.errorMessage,
        }}
        onClose={modal.onClose}
        useOriginMsg
      />
    );
  }

  return (
    <StandardModal
      title={t('client.get_paid.manual_verification_title')}
      onClose={modal.onClose}
      onSubmit={() => mutation.mutate({ email: modal.client.email }, { onSuccess: modal.onClose })}
      submittable={!mutation.isLoading}
      body={body}
      modalName="getPaidManualVerification"
      closeLabel={t('common.close')}
      submitLabel={t('common.submit')}
      containerStyle={{ width: 400 }}
    />
  );
};

export default GetPaidManualVerification;
